import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import useResponsive from "../util/useResponsive";
import DeviceList from "./DeviceList";
import ConnectedDevicesTable from "./ConnectedDevicesTable";
const ConnectedDevicesList = () => {
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    return isSmallScreen ? (_jsx(DeviceList, { title: t("connectedDevices") })) : (_jsx(Box, Object.assign({ px: 6, py: 4, width: "full" }, { children: _jsx(ConnectedDevicesTable, {}) })));
};
export default ConnectedDevicesList;
